"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import DOMPurify from "isomorphic-dompurify";
import dynamic from "next/dynamic";
import { SAMEDAYLINK, ZIPCODE_QUERY_PARAM } from "../../../utils/constants.js";
import parse from "html-react-parser";
import { useState, useEffect } from "react";
import "../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../Chrome/BrowseContext/hook.js";
import { COMPONENT_NAME } from "./constants.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
const BootstrapStyles = dynamic(
  () => import("./BootstrapStyles.js").then((mod) => ({ default: mod.BootstrapStyles }))
);
function getDataLayout(ad_type) {
  if (!ad_type) {
    return null;
  }
  const prefix = "rich_text_";
  const adType = ad_type;
  return `${prefix}${adType}`;
}
function RichTextEntryClient({
  rich_text_editor,
  entryId,
  ad_type
}) {
  const [isVisible, setIsVisible] = useState(false);
  const { deliveryLocation } = useBrowseContext();
  useEffect(() => {
    setIsVisible(true);
  }, []);
  if (!rich_text_editor) {
    return null;
  }
  const richText = typeof window !== "undefined" ? DOMPurify.sanitize(rich_text_editor, {
    ADD_TAGS: ["link", "script"],
    FORCE_BODY: true
  }) : "";
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      className: "with-bootstrap",
      "data-testid": `${COMPONENT_NAME}-${entryId}`,
      "data-layout": getDataLayout(ad_type),
      children: [
        /* @__PURE__ */ jsx(BootstrapStyles, {}),
        parse(richText, {
          replace: function(domNode, index) {
            var _a, _b, _c, _d, _e, _f;
            if (domNode.type === "tag" && ((_b = (_a = domNode == null ? void 0 : domNode.attribs) == null ? void 0 : _a.href) == null ? void 0 : _b.includes(SAMEDAYLINK))) {
              domNode.attribs.href = domNode.attribs.href.replace(
                ZIPCODE_QUERY_PARAM,
                ZIPCODE_QUERY_PARAM + deliveryLocation.zipCode
              );
            }
            if (domNode.type === "script") {
              const scriptId = domNode.attribs.id || `${entryId}_${index}`;
              const script = document.createElement("script");
              script.id = scriptId;
              if (domNode.attribs.type) {
                script.type = domNode.attribs.type;
              }
              if (domNode.attribs.src) {
                script.src = domNode.attribs.src;
              }
              if ((_d = (_c = domNode == null ? void 0 : domNode.children) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) {
                script.textContent = `${(_f = (_e = domNode == null ? void 0 : domNode.children) == null ? void 0 : _e[0]) == null ? void 0 : _f.data}`;
              }
              setTimeout(() => {
                try {
                  const existingScript = document.getElementById(scriptId);
                  if (existingScript) {
                    document.head.removeChild(existingScript);
                  }
                  document.head.appendChild(script);
                } catch {
                }
              });
              return /* @__PURE__ */ jsx(Fragment, {});
            }
          }
        })
      ]
    }
  );
}
export {
  RichTextEntryClient
};
